import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { ButtonBoxPropsType } from 'src/ui/components/button/common/types';
import { appearanceStyle, buildBtnDisabledOrLoading, sizeStyles } from 'src/ui/components/button/common/button-utils';
import { withConfig } from 'src/withConfig';

export const ButtonBox = withConfig(theme => styled('button', { label: 'ButtonBox' }) <ButtonBoxPropsType>`
    ${({ appearance }): SerializedStyles => appearanceStyle(theme, appearance)}
    ${({ size }): SerializedStyles => sizeStyles(theme, size)}
    ${({ disabled, isLoading }): SerializedStyles | null => buildBtnDisabledOrLoading(disabled, isLoading)};
    align-items: center;
    border: 0;
    cursor: pointer;
    display: flex;
    font-weight: ${theme.star.button.common.typography.fontWeightPrimary};
    justify-content: center;
    margin: 0;
    overflow: hidden;
    position: relative;
    &::after {
        content: '';
        inset: 0;
        opacity: 0;
        position: absolute;
        transition: opacity .2s ease;
    }
    &:hover,
    &:active {
        &::after {
            opacity: 1;
        }
    }
`);
